import { createSlice } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';

const initialState = {
    detailedHours: []  
};

const detailedHours = createSlice({
    name: 'detailedHours',
    initialState,
    reducers: {
        setDetailedHours(state, action) {
            // eslint-disable-next-line no-param-reassign
            state.detailedHours = action.payload;
        }
    }
});

export const useDetailedHours = () => {
    return useSelector((state) => state.detailedHours);
};

export const { setDetailedHours } = detailedHours.actions;

export default detailedHours.reducer;
